import * as tslib_1 from "tslib";
import { OnInit, EventEmitter, OnChanges, SimpleChanges, ElementRef, OnDestroy, DoCheck, QueryList } from '@angular/core';
import { FormControl, Validators, NgControl, NgForm, FormGroupDirective } from '@angular/forms';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete, MatAutocompleteTrigger, MatChipList, ErrorStateMatcher, MatOption } from '@angular/material';
import { isNullOrEmpty } from '@awp/core/utils';
import { _AwpComponentMixinBase } from '../custom-base.component';
export var DestinationType;
(function (DestinationType) {
    DestinationType[DestinationType["Region"] = 1] = "Region";
    DestinationType[DestinationType["Country"] = 2] = "Country";
    DestinationType[DestinationType["Location"] = 3] = "Location";
})(DestinationType || (DestinationType = {}));
var DestinationSelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DestinationSelectComponent, _super);
    function DestinationSelectComponent(ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher) {
        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
        _this.separatorKeysCodes = [ENTER, COMMA];
        _this.popularList = [];
        _this.formSearchControl = new FormControl();
        _this.formValueControl = new FormControl(null, { validators: [_this.validateRestrictedRegions.bind(_this)] });
        _this.isFilterActive = true;
        //values: Destination[] = null;
        _this.DestinationType = DestinationType;
        _this.destinations = [];
        _this.selected = [];
        _this.disabled = false;
        _this.required = false;
        _this.noMatchLabel = 'No matches found';
        _this.validationMessages = {};
        _this.selectionChanged = new EventEmitter();
        //#endregion
        // Allow click to toggle autocomplete panel, except on focus
        _this.canToggle = false;
        //#region ControlValueAccessor
        _this._onTouched = function () { };
        _this._onChange = function (value) { };
        if (_this.ngControl != null) { // Do this instead of NG_VALUE_ACCESSOR in providers above.
            _this.ngControl.valueAccessor = _this;
        }
        _this.errorStateMatcher = {
            isErrorState: function (control, form) {
                var oldState = _this.chipList != null ? _this.chipList.errorState : undefined;
                var newState = _defaultErrorStateMatcher.isErrorState(control, form);
                newState = newState || (_this.formSearchControl != null
                    && _this.formValueControl != null
                    && _this.formSearchControl.touched
                    && _this.formValueControl.invalid);
                if (_this.chipList != null && oldState !== newState) {
                    _this.chipList.errorState = newState;
                    _this.chipList.stateChanges.next(); // Need to ensure changeDetection is run inside the chiplist component.
                }
                return newState;
            }
        };
        return _this;
    }
    DestinationSelectComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.places = this.formSearchControl.valueChanges.pipe(startWith(null), debounceTime(300), map(function (value) {
            if (!isNullOrEmpty(value)) {
                _this.isFilterActive = true;
                return _this.applyFilter(value).sort(_this.sortList);
            }
            else {
                _this.isFilterActive = false;
                return _this.applyPopularFilter().sort(_this.sortList);
            }
        }));
    };
    DestinationSelectComponent.prototype.ngOnChanges = function (changes) {
        if (changes.destinations && changes.destinations.currentValue) {
            this.popularList = this.buildPopularList(changes.destinations.currentValue);
            this.formSearchControl.updateValueAndValidity();
        }
        if (changes.selected && changes.selected) {
            this.writeValue(changes.selected.currentValue);
        }
        if (changes.required) {
            if (changes.required.currentValue === true) {
                this.formValueControl.setValidators([Validators.required, this.validateRestrictedRegions.bind(this)]);
            }
            else {
                this.formValueControl.setValidators([this.validateRestrictedRegions.bind(this)]);
            }
            this.formValueControl.updateValueAndValidity();
        }
    };
    DestinationSelectComponent.prototype.ngOnDestroy = function () { };
    DestinationSelectComponent.prototype.ngDoCheck = function () {
        if (this.ngControl != null) {
            this.updateErrorState();
        }
    };
    DestinationSelectComponent.prototype.onChange = function (value) {
        var emittedValue = value != null && value.length > 0 ? tslib_1.__spread(value) : null;
        this.selectionChanged.emit(emittedValue);
        this._onChange(emittedValue);
        this._onTouched();
    };
    DestinationSelectComponent.prototype.writeValue = function (value) {
        this.formValueControl.setValue(value != null ? tslib_1.__spread(value) : []);
    };
    DestinationSelectComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    DestinationSelectComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    DestinationSelectComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled) {
            this.formSearchControl.disable();
        }
        else {
            this.formSearchControl.enable();
        }
    };
    //#endregion
    DestinationSelectComponent.prototype.validateRestrictedRegions = function (control) {
        var _this = this;
        if (isNullOrEmpty(this.restrictOriginRegionId)
            || this.formValueControl.value == null
            || this.formValueControl.value.length === 0) {
            return null;
        }
        ;
        if (window.location.href.indexOf("kiwibank") > -1)
            return null;
        if (this.formValueControl.value
            .filter(function (p) { return p.regionId == _this.restrictOriginRegionId; })
            .length === this.formValueControl.value.length) {
            return { regionInvalid: true };
        }
        return null;
    };
    DestinationSelectComponent.prototype.onBlur = function () {
        this.canToggle = false;
    };
    DestinationSelectComponent.prototype.toggle = function () {
        if (this.canToggle) {
            if (this.matAutoCompleteTrigger.panelOpen) {
                this.matAutoCompleteTrigger.closePanel();
            }
            else {
                this.matAutoCompleteTrigger.openPanel();
            }
        }
        else {
            this.canToggle = true;
        }
    };
    DestinationSelectComponent.prototype.remove = function (item) {
        var value = tslib_1.__spread(this.formValueControl.value);
        var index = value.indexOf(item);
        if (index >= 0) {
            value.splice(index, 1);
        }
        this.writeValue(value);
        this.onChange(value);
        this.formSearchControl.updateValueAndValidity();
        if (value.length == 0)
            this.input.nativeElement.placeholder = this.placeholder;
    };
    DestinationSelectComponent.prototype.optionSelected = function (event) {
        this.canToggle = true;
        var notifyOnChange = false;
        if (!this.formValueControl.value.includes(event.option.value)) {
            var value = tslib_1.__spread(this.formValueControl.value);
            value.push(event.option.value);
            this.writeValue(value);
            notifyOnChange = true;
            this.chipList.errorState = false;
        }
        this.input.nativeElement.value = '';
        this.input.nativeElement.placeholder = "";
        this.formSearchControl.setValue(null);
        if (notifyOnChange) {
            this.onChange(this.formValueControl.value);
        }
    };
    DestinationSelectComponent.prototype.add = function (autoComplete) {
        if (!this.matAutocomplete.isOpen && this.isFilterActive && this.matOptions != null) {
            var selected = this.matOptions.find(function (p) { return p.selected; });
            if (selected != null && !selected.disabled) {
                var event_1 = new MatAutocompleteSelectedEvent(autoComplete, selected);
                this.optionSelected(event_1);
            }
        }
    };
    DestinationSelectComponent.prototype.getSelectedIds = function () {
        return this.formValueControl.value != null ? this.formValueControl.value.map(function (p) { return p.id; }) : [];
    };
    DestinationSelectComponent.prototype.applyFilter = function (value) {
        var filterValue = value.toLowerCase();
        var selectedIds = this.getSelectedIds();
        return this.destinations.filter(function (p) { return !selectedIds.includes(p.id) // Remove current selection
            && p.destinationType !== DestinationType.Region // exclude regions
            && p.searchName.indexOf(filterValue) === 0; });
    };
    DestinationSelectComponent.prototype.applyPopularFilter = function () {
        if (this.popularList == null || this.popularList.length === 0)
            return [];
        var selectedIds = this.getSelectedIds();
        var result = this.popularList.filter(function (p) { return !selectedIds.includes(p.id); }); // Remove current selection
        var regions = new Set(result.map(function (p) { return p.destinationType !== DestinationType.Region ? p.regionId : null; }).filter(function (p) { return p != null; })); // Get Regions
        // filter regions that do not have any countries
        result = result.filter(function (p) {
            if (p.destinationType === DestinationType.Region) {
                return regions.has(p.id);
            }
            return true;
        });
        return result;
    };
    DestinationSelectComponent.prototype.buildPopularList = function (values) {
        var clonedList = values.map(function (p) { return (tslib_1.__assign({}, p)); });
        var regionList = clonedList.filter(function (p) { return p.destinationType === DestinationType.Region; });
        regionList.forEach(function (region) {
            region.sortOrder = region.sortOrder * 1000;
            var index = region.sortOrder + 1;
            var countryList = clonedList.filter(function (p) { return p.regionId === region.id; }).sort(function (a, b) { return a.searchName.localeCompare(b.searchName); });
            countryList.forEach(function (country) {
                country.sortOrder = index;
                index++;
            });
        });
        return clonedList.filter(function (p) { return p.isPopular; });
    };
    DestinationSelectComponent.prototype.sortList = function (a, b) { return (a.sortOrder < b.sortOrder) ? -1 : (a.sortOrder > b.sortOrder) ? 1 : 0; };
    return DestinationSelectComponent;
}(_AwpComponentMixinBase));
export { DestinationSelectComponent };
